import { render, staticRenderFns } from "./rili.vue?vue&type=template&id=ed7b0036&scoped=true"
import script from "./rili.vue?vue&type=script&lang=js"
export * from "./rili.vue?vue&type=script&lang=js"
import style0 from "./rili.vue?vue&type=style&index=0&id=ed7b0036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7b0036",
  null
  
)

export default component.exports